'use client';

export const windowScrollToBottom = (isUseAnimation: boolean = true) => {
  window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: isUseAnimation ? 'smooth' : 'instant' });
};
